module.exports = __webpack_public_path__ + "img/rejected.881488e7.svg";